import { store } from "../store";

export default (to: any, from: any, next: any) => {
  if (
    to.name !== "Signin" &&
    to.name !== "seja-bem-vindo" &&
    to.name !== "ResetPassword" &&
    to.name !== "ResetPasswordByLink"
  ) {
    if (store.getters.isLoggedIn) {
      return next();
    } else {
      next(`/signin`);
    }
  } else {
    if (store.getters.isLoggedIn) {
      return next("/");
    } else {
      return next();
    }
  }
};
